import type { DashboardFeatureConfig } from '../../types/features/DashboardFeatureConfig';

export const dashboard: DashboardFeatureConfig = {
    showContractNumber: false,
    showCurrentInstallment: false,
    showRemainingTerm: false,
    showAmountToPay: false,
};
